// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;How long will you nobles dishonour my glory;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;how long will you love vain things and seek after falsehood?<br> </p> </div></div>";
// Exports
module.exports = code;